import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

function ConfirmationModal({ type, title, description, confirmationText, confirm, open, onClose }) {
    const { t } = useTranslation();

    return (
        <>
            <Modal
                open={open}
                onClose={onClose}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: { xs: '100%', md: '50%' }
                }}
            >
                <Paper
                    sx={{
                        padding: '24px',
                        minWidth: { xs: '80%', md: '50%' },
                        maxWidth: { xs: '95%', md: '50%' }
                    }}
                >
                    <Typography variant='h6' gutterBottom>
                        {title}
                    </Typography>
                    <Typography variant='body2' gutterBottom>
                        {description}
                    </Typography>
                    <Stack
                        direction='row'
                        alignItems='center'
                        mt={4}
                        sx={{
                            justifyContent: {
                                xs: 'space-between',
                                md: 'flex-end'
                            }
                        }}
                    >
                        <Button
                            variant=''
                            onClick={onClose}
                            sx={{
                                borderRadius: '8px !important',
                                backgroundColor: 'rgba(33, 43, 54, 0.08)',
                                color: {
                                    xs: 'error.main',
                                    md: 'inherit'
                                },
                                '&:hover': {
                                    color: 'error.main'
                                }
                            }}
                        >
                            {t('modal.cancel')}
                        </Button>
                        <Button
                            variant=''
                            onClick={() => confirm()}
                            sx={{
                                ml: {
                                    xs: 0,
                                    md: 1
                                },
                                borderRadius: '8px !important',
                                backgroundColor: (theme) => ({
                                    xs: type === 'confirm' ? alpha(theme.palette.primary.main, 0.08) :
                                        type === 'remove' ? alpha(theme.palette.error.main, 0.08) :
                                            'inherit',
                                    md: 'rgba(33, 43, 54, 0.08)'
                                }),
                                color: {
                                    xs: type === 'confirm' ? 'primary.main' : type === 'remove' ? 'error.main' : 'inherit',
                                    md: 'inherit'
                                },
                                '&:hover': {
                                    color:
                                        type === 'confirm' ? 'primary.main' :
                                            type === 'remove' ? 'error.main' :
                                                'inherit',
                                    backgroundColor:
                                        type === 'confirm' ? (theme) => alpha(theme.palette.primary.main, 0.08) :
                                            type === 'remove' ? (theme) => alpha(theme.palette.error.main, 0.08) :
                                                'inherit'
                                }
                            }}
                        >
                            {confirmationText}
                        </Button>
                    </Stack>
                </Paper>
            </Modal>
        </>
    );
}

export default ConfirmationModal;